import React from "react";
import ReactPlayer from "react-player";

import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";

import { ReactComponent as CloseIcon } from "assets/images/icon_close_modal.svg";

interface VideoModalProps {
  isModalOpen: boolean;
  onClose: () => void;
  videoUrl: string;
}

const VideoModal: React.FC<VideoModalProps> = (props) => {
  const { isModalOpen, onClose, videoUrl } = props;

  return (
    <Dialog
      open={isModalOpen}
      onClose={onClose}
      fullScreen
      slotProps={{ paper: { sx: { p: "0 !important" } } }}
    >
      <Box sx={styles.playerWrapper}>
        <IconButton
          aria-label="close-video-player"
          onClick={onClose}
          sx={styles.closeButton}
        >
          <CloseIcon
            style={{ color: "white", width: "32px", height: "32px" }}
          />
        </IconButton>

        <ReactPlayer
          src={videoUrl}
          width="100%"
          height="100%"
          playing={isModalOpen}
          controls={true}
          config={{
            youtube: {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              cc_load_policy: 0 as any,
              iv_load_policy: 3,
            },
          }}
        />
      </Box>
    </Dialog>
  );
};

const styles = {
  playerWrapper: {
    width: "100%",
    height: "100%",
  },
  closeButton: {
    position: "absolute",
    top: "24px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 10,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
  },
};

export default VideoModal;
